/* @flow */

import type {
  ReduxState,
  Action,
  LiferayError,
  OnDemandType,
  WorklistItem,
  Track,
  Smartlist,
} from 'types';

// ===========================
//   STATE TYPE
// ===========================
export type OnDemandState = {
  isLoading: boolean,
  error: ?LiferayError,
  request?: { type: OnDemandType, data: WorklistItem[] | Track[] | Smartlist },
  request?:
    | { type: 'QUOTATION', data: WorklistItem[] }
    | { type: 'TRACKS', data: Track[] }
    | { type: 'SMARTLIST', data: Smartlist },
};

// ===========================
//   INITIAL STATE
// ===========================
export const initialState: OnDemandState = {
  isLoading: false,
  error: null,
};

// ===========================
//   REDUCER
// ===========================
export default (state: OnDemandState = initialState, action: Action): OnDemandState => {
  switch (action.type) {
    case 'SUBMIT_QUOTATION_REQUEST_REQUEST':
    case 'SUBMIT_ON_DEMAND_REQUEST_REQUEST': {
      return { ...state, isLoading: true, error: null };
    }
    case 'SUBMIT_QUOTATION_REQUEST_SUCCESS':
    case 'SUBMIT_ON_DEMAND_REQUEST_SUCCESS': {
      return {
        ...state,
        isLoading: false,
      };
    }
    case 'SUBMIT_QUOTATION_REQUEST_FAILURE':
    case 'SUBMIT_ON_DEMAND_REQUEST_FAILURE': {
      return { ...state, error: action.payload, isLoading: false };
    }
    case 'ON_DEMAND_ASK_QUOTATION': {
      const worklistItems = action.payload || [];
      return {
        ...state,
        request: {
          type: 'QUOTATION',
          data: worklistItems,
        },
      };
    }
    case 'ON_DEMAND_ASK_TRACKS': {
      const tracks = action.payload || [];
      return {
        ...state,
        request: {
          type: 'TRACKS',
          data: tracks,
        },
      };
    }
    case 'ON_DEMAND_ASK_SMARTLIST': {
      const smartlist = action.payload;
      return {
        ...state,
        request: {
          type: 'SMARTLIST',
          data: smartlist,
        },
      };
    }
    case 'LOGOUT_SUCCESS':
      return initialState;
    default: {
      return state;
    }
  }
};

// ===========================
//   SELECTORS
// ===========================

export const getIsLoading = (state: ReduxState): boolean => {
  return state.onDemand.isLoading;
};

export const getOnDemandRequest = (state: ReduxState) => {
  return state.onDemand.request;
};
